import { useTranslation } from "react-i18next";
import { cmsUrl } from "@kozien/shared";
import { useProducts } from "@/models/product";
import { useSunProtectionPageContent } from "@/models/sun-protection-settings";
import { useSelectionStore } from "@/store/selection";
import { TypeCard } from "@/components/molecules/TypeCard/TypeCard";
import { Skeleton } from "@/components/atoms/Skeleton/Skeleton";

export function TypeStep() {
    const { t } = useTranslation();
    const { selectedCategory, selectedTypeId, selectType } =
        useSelectionStore();
    const { products, loading, error } = useProducts(selectedCategory);
    const { data: pageContent } = useSunProtectionPageContent();

    const title = pageContent?.windowDressingStep?.title ?? t("typeStep.title");
    const subtitle =
        pageContent?.windowDressingStep?.content ?? t("typeStep.subtitle");

    if (loading) {
        return (
            <div className="flex flex-col gap-4">
                <Skeleton className="h-8 w-64 mx-auto" />
                <Skeleton className="h-4 w-80 mx-auto" />
                <div className="mt-4 grid grid-cols-2 gap-4 justify-center sm:grid-cols-[repeat(auto-fit,minmax(220px,280px))]">
                    {[1, 2, 3, 4].map((i) => (
                        <Skeleton key={i} className="rounded-2xl aspect-3/4" />
                    ))}
                </div>
            </div>
        );
    }

    if (error) {
        return (
            <p className="text-center text-gray-400 py-12">{error.message}</p>
        );
    }

    if (!selectedCategory) {
        return (
            <p className="text-center text-gray-400 py-12">
                {t("typeStep.noCategorySelected")}
            </p>
        );
    }

    return (
        <div className="flex flex-col gap-6">
            <div className="text-center">
                <h1 className="text-3xl font-bold text-gray-900 leading-tight">
                    {title}
                </h1>
                <p className="mt-2 text-sm text-gray-500 max-w-md mx-auto">
                    {subtitle}
                </p>
            </div>

            <div className="grid grid-cols-2 gap-4 justify-center sm:grid-cols-[repeat(auto-fit,minmax(220px,280px))]">
                {products.map((product) => (
                    <TypeCard
                        key={product.id}
                        id={product.id}
                        name={product.name}
                        subtitle={product.subtitle}
                        imageUrl={
                            product.image?.url
                                ? cmsUrl(
                                      product.image.url,
                                      import.meta.env.VITE_CMS_BASE_ENDPOINT,
                                  )
                                : null
                        }
                        selected={selectedTypeId === product.id}
                        onClick={() => selectType(product.id)}
                    />
                ))}
            </div>
        </div>
    );
}
